import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const BatchRevertToDraftDeliverableMutation = ids =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation BatchRevertToDraftDeliverableMutation(
          $input: RevertToDraftBatchDeliverableInput!
        ) {
          revertToDraftBatchDeliverable(input: $input) {
            updatedDeliverables {
              id
              state
            }
          }
        }
      `,
      variables: {
        input: {
          ids
        }
      },
      onCompleted: res => resolve(res.revertToDraftBatchDeliverable),
      onError: reject
    });
  });

export default BatchRevertToDraftDeliverableMutation;
